import { z } from 'zod'
import { ErrorCode } from '~/types/error'

// Matches the server's `schools.name_en` / `name_ja` `varchar(150)` columns.
const SCHOOL_NAME_MAX_LENGTH = 150

export const schoolSchema = z.object({
  nameEn: z.string().min(1, ErrorCode.REQUIRED).max(SCHOOL_NAME_MAX_LENGTH, ErrorCode.TOO_LONG),
  nameJa: z.string().min(1, ErrorCode.REQUIRED).max(SCHOOL_NAME_MAX_LENGTH, ErrorCode.TOO_LONG),
  // Only shown/editable once a school exists (create always sends `true` on
  // the server); kept in the shared schema so the edit dialog can reuse the
  // same form without a second resolver.
  isActive: z.boolean().default(true),
})

export type SchoolFormData = z.infer<typeof schoolSchema>

// `POST /admin/schools` only accepts nameEn/nameJa — isActive is server-defaulted.
export type CreateSchoolPayload = Pick<SchoolFormData, 'nameEn' | 'nameJa'>
